import React from 'react'
import {MainQuotePage, RecentOrderTable, RecentOffersSlider, MainSalesPersonPage} from './'
import { useQuoteOfferContext } from '../../Context/Cache/QuoteOffers/QuoteOfferContext'

const TogglePage = () => {
    const {activePage} =useQuoteOfferContext()
 
    return (
        <div className='flex flex-row-reverse w-full'>
            <RecentOffersSlider />
            <div className='w-full'>
                {activePage === 'quote' && <MainQuotePage />}
                {activePage === 'recentOrder' && <RecentOrderTable />}
                {/* {activePage === 'recentOrder1' && <MainSalesPersonPage />} */}
            </div>
        </div>
    )
}
 
export default TogglePage